import { SearchX } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface NoMatchStateProps {
  onClearFilters: () => void;
}

/**
 * Shown when the active filters narrow the current data to zero entries.
 * Mirrors EmptyState's centered card; offers a one-click reset.
 */
export function NoMatchState({ onClearFilters }: NoMatchStateProps) {
  return (
    <Card>
      <CardContent className="flex flex-col items-center gap-3 py-16 text-center">
        <div className="rounded-full bg-slate-100 p-3 text-slate-500">
          <SearchX className="h-6 w-6" />
        </div>
        <p className="text-sm font-medium text-slate-700">
          No entries match your filters
        </p>
        <Button onClick={onClearFilters}>Clear filters</Button>
      </CardContent>
    </Card>
  );
}
